import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NceService } from '../services/nce.service';
import { STATIC_VALUE } from '../../shared/configuration/static.value';

import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { StorageService } from '../../shared/services/storage.service';
import { FileService } from '../../shared/services/file.service';

@Component({
    selector: 'nce-view',
    templateUrl: '../../shared/components/preview/preview-parent.component.html'
})
export class NceViewComponent{

    vNCEid: number;
    sub: any;

    constructor(
        private _nceService: NceService,
        private _layoutService: LayoutService,
        private _storageService: StorageService,
        private _pageNavigationService: PageNavigationService,
        private _activatedRoute: ActivatedRoute,
        private _fileService: FileService,
    ) { }

    ngOnInit() {
    	this._layoutService.setCurrentPage('nce-view');
        this.sub = this._activatedRoute.params.subscribe(params => {
            this.vNCEid = params['id'];
        });
        this._nceService.loadDetailNCE(this.vNCEid).then(
            (resolve) => {
                this.setCurrentFlow();
            },
            (reject) => {

            }
        );
    }

    ngOnDestroy(){
        this._storageService.removeSessionItem('extensionNCE');
    }

    setCurrentFlow(){
        if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PAYMENT_IN_PROGRESS ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PAYMENT_FAILED || 
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PAYMENT_PENDING){
            this._layoutService.setNCEFlow('nce-payment');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_SCHEDULE || 
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_PROVISIONING){
            this._layoutService.setNCEFlow('nce-briefing-session');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_DOCUMENT ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED_BRIEFING_DOCUMENT){
            this._layoutService.setNCEFlow('nce-briefing-document');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_TRIAL_HOLE_INSPECTION ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.WAIT_DIVERSION||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_SCHEDULE){
            this._layoutService.setNCEFlow('nce-make-appointment');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.APPOINTMENT_DOCUMENT_UPLOAD ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED_APPOINTMENT_DOCUMENT){
            this._layoutService.setNCEFlow('nce-appointment-upload');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_DOCUMENT){
            this._layoutService.setNCEFlow('nce-appointment-document');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLY_FINAL_APPROVAL ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLY_FINAL_APPROVAL_REJECTED ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.INSPECTION_FINAL_APPROVAL){
            this._layoutService.setNCEFlow('nce-apply-for-final-approval');
        } else if(
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_FINAL||
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED||
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.APPROVED || 
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.EXPIRED ||
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLICATION_EXPIRED ||
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.CANCELLED){
                this._layoutService.setNCEFlow('nce-final-approval');
        }
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/components/view.component.ts